/*@ngInject*/
const WizardMediator = function (wizardContextModel) {

    this.setContextId = function (contextId) {
        wizardContextModel.setContextId(contextId);
    };

    this.getContextId = function () {
        return wizardContextModel.getContextId();
    };

    this.setContextType = function (contextType) {
        wizardContextModel.setContextType(contextType);
    };

    this.getContextType = function () {
        return wizardContextModel.getContextType();
    };

    this.setContextLabel = function (contextLabel) {
        wizardContextModel.setContextLabel(contextLabel);
    };

    this.getContextLabel = function () {
        return wizardContextModel.getContextLabel();
    };

    this.setContextUri = function (contextUri) {
        wizardContextModel.setContextUri(contextUri);
    };

    this.getContextUri = function () {
        return wizardContextModel.getContextUri();
    };

    this.setHierarchicalContextList = function (hierarchicalContextList) {
        wizardContextModel.setHierarchicalContextList(hierarchicalContextList);
    };

    this.getHierarchicalContextList = function () {
        return wizardContextModel.getHierarchicalContextList();
    };

    this.setContext = function (context) {
        wizardContextModel.setContext(context);
    };

    this.getContext = function () {
        return wizardContextModel.getContext();
    };

    this.resetContext = function () {
        wizardContextModel.resetContext();
    };

};

angular.module('gw-um-submission').service('wizardMediator', WizardMediator);
